import TaskExampleImage from "components/ExampleImage/TaskExampleImage";
import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import {
  TemplateTaskActionButton,
  PrebuiltTemplateTaskActionButton,
  PrebuitTaskTemplateActionButtonParentProps,
  TaskTemplateActionButtonParentProps,
  TemplateTaskActionCloseButton,
} from "./TemplateTaskActionButton";
import TemplateActionText from "../TemplateActionText";

export default function TemplateInputOnboardingPlanTaskAction({ autoOpen, setAutoOpen, onRemove }: TaskTemplateActionButtonParentProps) {
  useEffect(() => {
    if (autoOpen) {
      setAutoOpen(false);
    }
  }, [autoOpen, setAutoOpen]);
  return (
    <TemplateTaskActionButton autoOpen={autoOpen} onRemove={onRemove} buttonText="Onboarding Plan Input" buttonTitle="Onboarding Plan Input">
      <Flex direction="column" pb="4" gap="6" w="100%">
        <TemplateActionText text="Enter an Onboarding Plan" />
        <TaskExampleImage taskType="create_onboarding_plan" />
      </Flex>
      <TemplateTaskActionCloseButton />
    </TemplateTaskActionButton>
  );
}

export function PrebuiltTemplateInputOnboardingPlanTaskAction({ prebuiltTaskTemplate }: PrebuitTaskTemplateActionButtonParentProps) {
  return (
    <PrebuiltTemplateTaskActionButton buttonText="Onboarding Plan Input" buttonTitle="Onboarding Plan Input">
      <Flex direction="column" pb="4" gap="6" w="100%">
        <TemplateActionText text="Enter an Onboarding Plan" />
        <TaskExampleImage taskType="create_onboarding_plan" />
      </Flex>
    </PrebuiltTemplateTaskActionButton>
  );
}
